const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

async function clearServiceWorkersAndCaches() {
  if ('serviceWorker' in navigator) {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));
  }
  if ('caches' in window) {
    const names = await caches.keys();
    await Promise.all(names.map((n) => caches.delete(n)));
  }
}

/**
 * Register SW only in production builds.
 * In development, actively unregister so webpack-dev-server is not intercepted
 * (SW cache-first on hot-reloaded bundles causes request loops).
 */
export function register(config) {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  // Dev / localhost: never control the page with a SW — unregister immediately and on load
  if (process.env.NODE_ENV !== 'production') {
    clearServiceWorkersAndCaches().catch(() => {});
    window.addEventListener('load', () => {
      clearServiceWorkersAndCaches().catch(() => {});
    });
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;

          installingWorker.onstatechange = () => {
            if (installingWorker.state !== 'installed') return;

            if (navigator.serviceWorker.controller) {
              if (config?.onUpdate) {
                config.onUpdate(registration);
              }
            } else if (config?.onSuccess) {
              config.onSuccess(registration);
            }
          };
        };
      })
      .catch(() => {});
  });
}

export function unregister() {
  clearServiceWorkersAndCaches().catch(() => {});
}

// Keep isLocalhost available for callers that need it
export { isLocalhost };
